import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { AddInterest } from "./addModal";
import { loadInterests } from "./loadData";
import { InterestHeaders } from "./tableHeaders";

const Interests = ({}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [interests, setInterests] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);

  useEffect(() => {
    loadInterests(setLoading).then(setInterests);
  }, [location.pathname, update]);

  return (
    <AdminPage title="Interests">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Interests Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.interestName}
            description={viewModalData?.interestDescription}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete User"}
        deleteModal={true}
        InternalComponent={
          <DeleteModalContent
            route={`interest/deleteInterest/${deleteData}`}
            type={"User"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />
      <AddInterest
        opened={opened}
        setOpened={setOpened}
        setUpdate={setUpdate}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={InterestHeaders}
          rowData={interests}
          opened={opened}
          setOpened={setOpened}
          showAddButton={true}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(Interests);
